<template>
    <div class="content_module">
            <div class='content'>
                <p class='title1'>{{technical_features.title}}</p>
                <p class='title2'>{{technical_features.value}}</p>
                <p class='title3'><span></span></p>
                
                <ul>
                    <li ref="Item">
                        <p v-html="technical_features.mes"></p>
                    </li>
                    <li :style="{width:technical_features.img_width}" style="flex:0 0 auto;" ref="Item1">
                        <img :src="technical_features.img_src" />
                    </li>
                </ul>
            </div>
    </div>
</template>

<script>
export default {
  name: 'technical-features',
  props:["technical_features"],
  data () {
    return {
    }
  },
  created:function(){
    let self = this;
  },
  mounted () {
    let self = this
    let rightReveal=self.$root.$data.rightReveal
    let leftReveal=self.$root.$data.leftReveal
    let topReveal=self.$root.$data.topReveal
    let fooReveal=self.$root.$data.fooReveal
    let fadeReveal=self.$root.$data.fadeReveal
    self.$scroll().reveal(self.$refs.Item,{...leftReveal,delay:200})
    self.$scroll().reveal(self.$refs.Item1,{...rightReveal,delay:200})
  },
}
</script>

<style scoped>
@import '../../../../static/css/common.css';

.content_module{
    position:relative;
    background-color:#f9fafc;
}

.content_module .back{
    position:absolute;
    z-index:0;
    width:100%;
    top:auto;
    height:1em;
    text-align:center;
    font-size:360px;
    overflow:hidden;
    margin:0 auto;
    bottom:250px;
    color:rgba(245,248,255,0.4);
}

.content{
    width:900px;
    margin:0 auto;
    position:relative;
    display:flex;
    justify-content:center;
    flex-wrap:wrap;
    padding:30px 0;
}
ul{
    display:flex;
    width:100%;
    justify-content:space-between;
    margin-top:30px;
}
li{
    list-style:none;
    flex:1 1 auto;
}
.content_module .content li p{
    width:auto;
    float:left;
    text-align:justify;
    font-size:16px;
    color:#575757;
    line-height:24px;
    padding-right:45px;
} 
.content_module .content li img{
    width:100%;
} 
</style>
<style scoped>
@media screen and (max-width: 764px) { 
    ul{
        flex-wrap:wrap;
    }
    li{
        width:100% !important;
    }
    .content_module .content li p{
        padding-right:0;
        padding-bottom:20px;
    }
} 
</style> 



// WEBPACK FOOTER //
// src/components/common/product_center/technical_features.vue